import React, {useState} from 'react';
import {Link} from "@inertiajs/inertia-react";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import {ButtonGroup} from "react-bootstrap";
import {Inertia} from "@inertiajs/inertia";

export default function Pagination({state, dispatch}) {
    const initialHowManyTitle = ([<span key="per_page">{state.pagination.per_page}</span>,
        <span key="angle" className="how-many-title-span"><i className="fa fa-angle-down"></i></span>])
    const [howManyTitle, setHowManyTitle] = useState(initialHowManyTitle);
    const initialPageRangeStart = Math.floor((state.pagination.current_page - 1) / 10) * 10 + 1;
    const [pageRangeStart, setPageRangeStart] = useState(initialPageRangeStart);
    const [fromItem, toItem] = retrieveToFromPerPageItems();
    const handlePageClick = (page) => {
        dispatch({ type: "page", payload: { page } });
    };

    const handleDotsClick = () => {
        setPageRangeStart(pageRangeStart + 10);
    };

    return (
        <div className="pagination-wrap">
            <div className="d-flex align-items-center">
                <nav>
                    <ul className="pagination">
                        {/* Previous Button */}
                        <li className={`page-item ${state.pagination.current_page === 1 ? 'disabled' : ''}`}>
                            <a className="page-link"
                               onClick={() => {
                                   if (state.pagination.current_page > 1) {
                                       dispatch({
                                           type: "page",
                                           payload: {page: state.pagination.current_page - 1}
                                       });
                                   }
                               }}
                            >
                                <i className="fa fa-angle-left pe-auto"></i>
                            </a>
                        </li>
                        {Array.from({length: state.pagination.last_page}).map((_, index) => {
                            const page = index + 1;
                            if (page >= pageRangeStart && page < pageRangeStart + 10) {
                                return (
                                    <li
                                        key={page}
                                        className={`page-item ${state.pagination.current_page === page ? 'active' : ''}`}
                                    >
                                        <a
                                            className="page-link pe-auto"
                                            onClick={() => handlePageClick(page)}
                                        >
                                            {page}
                                        </a>
                                    </li>
                                );
                            }

                            if (page === pageRangeStart + 10) {
                                return (
                                    <li key={page} className="page-item">
                                        <span className="page-link pe-auto" onClick={handleDotsClick}>...</span>
                                    </li>
                                );
                            }

                            if (page === state.pagination.last_page || page === state.pagination.last_page - 1) {
                                return (
                                    <li
                                        key={page}
                                        className={`page-item ${state.pagination.current_page === page ? 'active' : ''}`}
                                    >
                                        <a
                                            className="page-link pe-auto"
                                            onClick={() => handlePageClick(page)}
                                        >
                                            {page}
                                        </a>
                                    </li>
                                );
                            }

                            return null;
                        })}

                        <li
                            className={`page-item ${state.pagination.current_page === state.pagination.last_page ? 'disabled' : ''}`}
                        >
                            <a className="page-link"
                               onClick={() => {
                                   if (state.pagination.current_page < state.pagination.last_page) {
                                       dispatch({
                                           type: "page",
                                           payload: {page: state.pagination.current_page + 1}
                                       });
                                   }
                               }}
                            >
                                <i className="fa fa-angle-right pe-auto"></i>
                            </a>
                        </li>
                    </ul>
                </nav>
                <div className="how-many">
                    <div className="how-many-label">Show:</div>
                    <DropdownButton
                        as={ButtonGroup}
                        drop="up"
                        title={howManyTitle}
                        variant="toolbar"
                        onToggle={(e) => changeHowManyTitle(e)}
                    >
                        {howManyItems()}
                    </DropdownButton>
                </div>
            </div>
            <div className="pagination-summary">
                {`Showing ${fromItem}-${toItem} of ${state.pagination.total}`}
            </div>
        </div>
    );

    function retrieveToFromPerPageItems() {
        const { current_page, per_page, total } = state.pagination;
        const from = (current_page - 1) * per_page + 1;
        const to = current_page * per_page;
        const toMax = Math.min(to, total); // Use Math.min for a cleaner comparison
        return [from, toMax];
    }

    function changeHowManyTitle(open = false) {
        setHowManyTitle((
            [<span key="per_page">{state.pagination.per_page}</span>,
                <span key="angle" className="how-many-title-span"><i
                    className={`fa ${open ? 'fa-angle-up' : 'fa-angle-down'}`}></i></span>]
        ));
    }

    function howManyItems() {
        const rowsPerPageIncrements = [10, 25, 50, 100, 200, 400]
        let increments = [];
        rowsPerPageIncrements.every((increment, index) => {
            increments.push(increment);
            if (state.pagination.total <= increment) {
                return false;
            }

            return increments;
        })
        return (
            increments.reverse().map((increment) =>
                <Dropdown.Item key={increment}
                               eventKey={increment}
                               onClick={() => {
                                   dispatch({type: "pageSize", payload: {pageSize: increment}})
                               }
                               }
                >{increment}</Dropdown.Item>)
        )
    }
}
